import { ReactNode } from "react";
import AppHeader from "./AppHeader";
import StepHeader from "./StepHeader";
import { PageContainer, PageContent } from "../styles/layoutStyles";

const pageHeaderLogo = new URL("../assets/images/smaul_logo_long.png", import.meta.url).href;

type PageLayoutProps = {
  completed?: boolean;
  children: ReactNode;
};

export default function PageLayout({ completed = false, children }: PageLayoutProps) {
  return (
    <PageContainer>
      <AppHeader
        logoSrc={pageHeaderLogo}
        logoAlt="SMAUL スマウル"
        logoWidth={182}
      />
      <PageContent>
        <StepHeader completed={completed} />
        {children}
      </PageContent>
    </PageContainer>
  );
}
